export default {
	// install方法是必需的
	// 包含两个参数：Vue 构造器，一个可选的选项对象
	install: function(Vue, options) {
		// 使用minxin将功能注入所有组件
		Vue.mixin({
			data(){
				return {}
			},
            computed:{
                // 编辑器主题配置
                'editorTheme':{
                    get(){
                        // return this.$store.state.editorTheme
						return "clouds"
                    },
                    set(val){
                        // this.$store.state.editorTheme = val
                    }
                }
            },
			// 添加到mixin中的任何内容将被注入到所有组件中。
			//在这个例子中， mounted() 方法将在组件被挂载到DOM后调用
			methods: {
				// 编辑器初始化
				editorInit($ace) {
					//searchbox过滤框，快捷键ctrl+F
					require('brace/ext/searchbox')
					// 好像是检测语法
					require('brace/ext/language_tools') //language extension prerequsite...
					// 语言(可以直接在brace/mode目录下查看)
					require('brace/mode/json')
					require('brace/mode/javascript')
					require('brace/mode/less')
					require('brace/mode/html')
					require('brace/mode/xml')
					require('brace/mode/text')
					// 主题 github、tomorrow、kuioir、twilight、xcode、textmeta、terminal、solarized-light、solarized-dark
					require('brace/theme/clouds')
					require('brace/theme/github')
					require('brace/theme/crimson_editor')
					require('brace/theme/chrome')
					require('brace/theme/dawn')

					// 黑蓝色
					require('brace/theme/tomorrow_night_blue')
					require('brace/theme/cobalt')
					// 黑色阴影
					require('brace/theme/ambiance')
					// 黑色
					require('brace/theme/chaos')
					require('brace/theme/clouds_midnight')

                    // 保存当前对象
                    this.$ace = $ace

					// // 监听值的变化
					// $ace.getSession().on('change', () => {
					// 	console.log($ace.getValue())
					// })

					// 不知道为什么复制不能生效，剪贴可以生效，用下面的方法补救
					// $ace.on('copy', function(e) {
					// 	console.log(e)
					// 	// e.clipboardData.setData('text/plain', $ace.getValue());
					// 	// e.preventDefault(); // 阻止默认行为
					// });

					$ace.commands.addCommand({
						name: 'myCommand',
						bindKey: {win: 'Ctrl-C',  mac: 'Command-C'},
						exec: (editor)=>{
							this.$copyText( editor.session.getTextRange(editor.getSelectionRange()) ).then(function (e) {
								// console.log(e)
							}, function (e) {
								// console.log(e)
							})
						}
					});
				},
			},
		});
	}
};
